import { SxProps } from "@outschool/backpack";
import { useSession } from "@outschool/ui-auth";
import { TrackedButton } from "@outschool/ui-components-shared";
import { useNavigation } from "@outschool/ui-utils";
import React from "react";

type LandingPageCtaButtonProps = {
  ctaText: string;
  ctaUrl: string;
  ctaUrlLoggedIn: string;
  pageSection: string;
  sx?: SxProps;
};

export default function LandingPageCtaButton({
  ctaText,
  ctaUrl,
  ctaUrlLoggedIn,
  pageSection,
  sx,
  size = "medium"
}: LandingPageCtaButtonProps & { size?: "medium" | "large" }) {
  const { isLoggedIn } = useSession();
  const navigate = useNavigation();

  const onClickButton = React.useCallback(() => {
    if (isLoggedIn) {
      navigate(ctaUrlLoggedIn);
    } else {
      navigate(ctaUrl);
    }
  }, [isLoggedIn, ctaUrlLoggedIn, ctaUrl, navigate]);

  return (
    <TrackedButton
      onClick={onClickButton}
      trackingName={"landing_page_cta_button_touch"}
      trackingSharedProperties={{
        ctaText,
        ctaUrl,
        pageSection
      }}
      size={size}
      variant="contained"
      sx={[...(Array.isArray(sx) ? sx : [sx])]}
    >
      {ctaText}
    </TrackedButton>
  );
}
